import React from "react";
import "./UaeTopContent.css"
const UaeTopContent = () => {
  return (
    <div className="topContent-container">
      <h2>UAE Attestation Process – Important Information</h2>
      <p>
        At Goodway Attestation, the entire UAE attestation process is completed
        within India, and there is no requirement to send original documents to
        the UAE at any stage. In most cases, documents must undergo both UAE
        Embassy attestation and Ministry of Foreign Affairs (MOFA) attestation
        to be considered valid for official use. Completing only the UAE Embassy
        attestation is generally not sufficient without MOFA validation, as per
        current regulatory requirements.
      </p>
      <p>
        The attestation process follows a strictly defined government-approved
        sequence, including Notary Public attestation, Sub-Divisional Magistrate
        (SDM) or state-level authentication, verification by the Ministry of
        External Affairs (MEA), UAE Embassy attestation in India, and finally
        MOFA attestation. Each step is carried out in full compliance with
        official regulations to ensure international acceptance of your
        documents.
      </p>
      <p>
        With Goodway Attestation, you receive professional guidance, secure
        document handling, and timely processing through every stage of the
        procedure, ensuring a smooth and reliable attestation experience.
      </p>
    </div>
  );
};

export default UaeTopContent;
